import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import dayjs from 'dayjs';
import React__default, { useMemo } from 'react';
import { ExpandedFdocSidebarAddComment } from './ExpandedFdocSidebar_AddComment.js';
import { styled } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { ScrollArea } from '@fabric-app/ui/components/ScrollArea';
import CommentComponent from '../../../comments/components/Comment.js';
import { Conversation } from '@fabric-app/ui/components/Conversation';
import { ForcedTheme } from '@fabric-app/ui/theme/ForcedTheme';
import { AnimatePresence } from 'framer-motion';

const ItemPreviewSidebarCommentsEmpty = styled.span.withConfig({
  displayName: "ExpandedFdocCommentsTab__ItemPreviewSidebarCommentsEmpty",
  componentId: "sc-feb47bbc-0"
})([
  `margin-top:40px;color:rgba(255,255,255,0.5);text-align:center;font-size:13px;font-family:Inter,sans-serif;width:100%;display:block;&[data-fullscreen='true']{color:`,
  `;}`
], cssVar["color-text-tertiary"]);
const ExpandedFdocCommentsTab = ({ isFullscreen, comments, onStartEditingComment, editingComment, onCancelEditingComment, resourceId, animateIn, canAutoFocus = false }) => {
  const commentsWithDates = useMemo(() => {
    let lastDay = null;
    const commentsWithDates2 = comments.slice(0).sort((a, b) => dayjs(a.createdAt).unix() - dayjs(b.createdAt).unix()).reduce((acc, comment) => {
      const day = dayjs(comment.createdAt).format("ddd, MMM D");
      if (day !== lastDay) {
        acc.push({
          day,
          comments: []
        });
        lastDay = day;
      }
      acc[acc.length - 1].comments.push(comment);
      return acc;
    }, []);
    return commentsWithDates2;
  }, [
    comments
  ]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(ForcedTheme, {
        asChild: true,
        colorScheme: "dark",
        disabled: isFullscreen,
        children: /* @__PURE__ */ jsx(CommentsScrollArea, {
          scrollbarVariant: "subtle",
          fade: "end",
          style: {
            flexGrow: 1
          },
          children: /* @__PURE__ */ jsx(Conversation.List, {
            children: /* @__PURE__ */ jsxs(Fragment, {
              children: [
                comments.length === 0 && /* @__PURE__ */ jsx(ItemPreviewSidebarCommentsEmpty, {
                  "data-fullscreen": isFullscreen,
                  children: "No comments yet."
                }),
                commentsWithDates.map(({ day, comments: comments2 }, i) => /* @__PURE__ */ jsxs(React__default.Fragment, {
                  children: [
                    /* @__PURE__ */ jsx(Conversation.InfoTag, {
                      children: day
                    }),
                    comments2?.map((comment) => {
                      return /* @__PURE__ */ jsx(CommentComponent, {
                        comment,
                        resourceId,
                        onEdit: () => onStartEditingComment(comment),
                        light: isFullscreen
                      }, comment.id);
                    })
                  ]
                }, `${day}-${comments2.length}-${i}`))
              ]
            })
          })
        })
      }),
      editingComment !== void 0 && onCancelEditingComment && resourceId && /* @__PURE__ */ jsx(AnimatePresence, {
        initial: animateIn,
        children: /* @__PURE__ */ jsx(ExpandedFdocSidebarAddComment, {
          isFullscreen,
          editingComment,
          onCancelEditingComment,
          resourceId,
          canAutoFocus
        }, "add-comment-input")
      })
    ]
  });
};
const CommentsScrollArea = styled(ScrollArea.Default).withConfig({
  displayName: "ExpandedFdocCommentsTab__CommentsScrollArea",
  componentId: "sc-feb47bbc-1"
})([
  `--scroll-area-fade-bg-color:`,
  `;`
], cssVar["color-bg-assistant"]);

export { ExpandedFdocCommentsTab as default };
//# sourceMappingURL=ExpandedFdocCommentsTab.js.map
